import defaultLang from './lang/zh-CN'
import { getCurrentInstance, ref } from 'vue'
import Format from './format'

const format = Format()
let lang = defaultLang
// 响应式语言标记，用于触发组件更新
export const langKey = ref(0)
// 语言变更监听器
const listeners = new Set()

let i18nHandler = function () {
	// Vue 3 兼容：尝试获取当前实例的 $t 方法
	let vuei18n = null

	try {
		const instance = getCurrentInstance()
		if (instance) {
			// 优先从全局属性获取
			vuei18n = instance.appContext?.app?.config?.globalProperties?.$t
			// 其次从代理对象获取
			// if (!vuei18n && instance.proxy?.$t) {
			//   vuei18n = instance.proxy?.$t;
			// }
		}
	} catch (e) {
		// 在非组件上下文中调用时，getCurrentInstance 可能会失败
		// 这种情况下继续使用内置的翻译逻辑
	}

	if (typeof vuei18n === 'function') {
		return vuei18n.apply(this, arguments)
	}

	// 如果没有找到 vue-i18n，返回 null 让后续逻辑处理
	return null
}

export const t = function (path, ...options) {
	let value = i18nHandler.apply(this, arguments)
	// 当 vue-i18n 返回的值等于 key 本身时（表示未找到翻译），回退到内置语言包
	if (value !== null && value !== undefined && value !== path) return value

	const array = path.split('.')
	let current = lang

	for (let i = 0, j = array.length; i < j; i++) {
		const property = array[i]
		value = current[property]
		if (i === j - 1) return format(value, options)
		if (!value) return ''
		current = value
	}
	return ''
}

export const use = function (l) {
	lang = l || lang
	// 更新响应式标记，触发组件重新渲染
	langKey.value++
	// 通知所有监听器
	listeners.forEach(fn => fn(lang))
}

// 添加语言变更监听器
export const onLangChange = function (fn) {
	listeners.add(fn)
	return () => listeners.delete(fn)
}

export const i18n = function (fn) {
	i18nHandler = fn || i18nHandler
}

export default { use, t, i18n, langKey: langKey.value, onLangChange }
